import styled from 'styled-components';

interface ButtonProps {
    primary?: boolean;
  }

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const ModalWrapper = styled.div`
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 2rem 4rem;
`;

export const ModalTitle = styled.h2`
  font-size: 3rem;
  margin-top: 0;
`;

export const InputWrapper = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

export const Input = styled.input`
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 2rem;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  gap: 1rem;
`;

export const Button = styled.button<ButtonProps>`
  padding: 1rem 2rem;
  border-radius: 4px;
  font-size: 2rem;
  cursor: pointer;
  width: 120px;
  background-color: ${({ primary }) => (primary ? '#007bff' : '#fff')};
  color: ${({ primary }) => (primary ? '#fff' : '#333')};
  border: ${({ primary }) => (primary ? 'none' : '1px solid #ccc')};
`;